import { useState } from "react";
import { Typography, Box, Link, Switch } from "@mui/material";
import { LoadingError, LoadingPaper } from "../../LoadingComponents";
import { renderEUDateTimeLong, prettify } from "../../../utils/utils";
import { useGetDoctors } from "../../DoctorComponents";
import { useGetTelevisitById } from "../useTelevisitQueries";
import { EditableInputDisplay } from "../../EditableComponents";

function ViewTelevisit({ televisit_id, editMode, updateEditState }) {
  // === web service queries/mutations ===
  const doctorsQuery = useGetDoctors();
  const televisitQuery = useGetTelevisitById(televisit_id);

  return (
    <>
      {televisitQuery.isLoading ? (
        <LoadingPaper />
      ) : televisitQuery.isError ? (
        <LoadingError error={televisitQuery.error} />
      ) : (
        televisitQuery.data !== undefined && (
          <Box
            sx={{
              display: "grid",
              margin: "auto",
              gridTemplateColumns: "1fr 1fr",
              width: "100%",
            }}
          >
            <Box sx={{ margin: "10px" }}>
              <EditableInputDisplay
                id={"subject"}
                label={"Oggetto:"}
                initialValue={televisitQuery.data.subject}
                setEditMode={editMode}
                inputMode={"text"}
                setParentValue={updateEditState}
              />
              {televisitQuery.data.note.length === 0 ? (
                <Typography>"Nessuna nota disponibile"</Typography>
              ) : (
                <EditableInputDisplay
                  id={"note"}
                  label={"Note:"}
                  initialValue={televisitQuery.data.note}
                  setEditMode={editMode}
                  inputMode={"text"}
                  setParentValue={updateEditState}
                />
              )}
              <EditableInputDisplay
                id={"send_patient_email"}
                label={"Invia email al paziente:"}
                initialValue={televisitQuery.data.send_patient_email}
                setEditMode={editMode}
                inputMode={"bool"}
                setParentValue={updateEditState}
              />
              <EditableInputDisplay
                id={"send_patient_sms"}
                label={"Invia sms al paziente:"}
                initialValue={televisitQuery.data.send_patient_sms}
                setEditMode={editMode}
                inputMode={"bool"}
                setParentValue={updateEditState}
              />
              <EditableInputDisplay
                id={"send_colleagues_email"}
                label={"Invia email al prof. sanitario:"}
                initialValue={televisitQuery.data.send_colleagues_email}
                setEditMode={editMode}
                inputMode={"bool"}
                setParentValue={updateEditState}
              />
              <EditableInputDisplay
                id={"send_colleagues_sms"}
                label={"Invia email al prof. sanitario:"}
                initialValue={televisitQuery.data.send_colleagues_sms}
                setEditMode={editMode}
                inputMode={"bool"}
                setParentValue={updateEditState}
              />
            </Box>

            <Box sx={{ margin: "10px" }}>
              <Typography>
                <strong>Stato:</strong>{" "}
                {televisitQuery.data.is_done ? "Completata" : "Da fare"}
              </Typography>
              <Typography sx={{ marginTop: "10px" }}>
                <strong>Colleghi invitati:</strong>
              </Typography>
              {televisitQuery.data["invitedColleagues"] !== undefined ? (
                <ul>
                  {televisitQuery.data["invitedColleagues"].map((el) => (
                    <li key={crypto.randomUUID()}>
                      {el.first_name} {el.last_name}
                    </li>
                  ))}
                </ul>
              ) : (
                "Nessun collega invitato"
              )}
            </Box>
          </Box>
        )
      )}
    </>
  );
}

export default ViewTelevisit;
